import { preloadRecaptchaOnInteraction } from './recaptcha-loader';

export function initRecaptchaLazyLoad() {
    document
        .querySelectorAll('[name="g_recaptcha_key"]')
        .forEach(input => {
            const key = (input.value || '').trim();
            const form = input.closest('form');

            if (!key || !form) {
                return;
            }

            preloadRecaptchaOnInteraction(form, key);
        });
}
